import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-status-icon',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './status-icon.component.html',
})
export class StatusIconComponent {
  @Input() requested: boolean | undefined;
  @Input() queryStatus: string | any;
  @Input() tooltip: string | undefined;
}
